module.exports = __webpack_public_path__ + "static/media/n_icon_shouyimingxi.247d9bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_shouyimingxi.png
// module id = 673
// module chunks = 0 1